import React from "react";
import styled from "styled-components";

interface Props {
  color: string;
  className?: string;
}

export const Loader: React.FC<Props> = ({ color, className }) => {
  return (
    <svg viewBox="0 0 800 800" width="150" height="150" className={className}>
      <defs>
        <mask id="ringMask">
          <circle
            cx="400"
            cy="400"
            r="370"
            stroke="white"
            strokeWidth="50"
            fill="none"
          />
        </mask>
      </defs>

      <Gradient x="0" y="0">
        <div
          style={{
            background: `conic-gradient(from 0deg, transparent 0deg, ${color} 360deg)`,
            mask: "url(#ringMask)",
            WebkitMask: "url(#ringMask)",
          }}
        />
      </Gradient>
    </svg>
  );
};

const Gradient = styled.foreignObject`
  width: 800px;
  height: 800px;

  div {
    width: 100%;
    height: 100%;
    animation: rotateLoader 1.5s linear infinite;

    @keyframes rotateLoader {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`;
